export * from './confirm-dialog'



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-dialog/index.ts